import React from 'react';

import { CatalogInfoContainer } from 'src/components/containers';


const FaunaCatalogInfoContainer = () => <CatalogInfoContainer apiType='fauna' />;


export { FaunaCatalogInfoContainer };
